import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconCloseThin } from '@medifind/icons';
import { Button } from './inputs/Button';
import styles from './Chip.module.scss';

const Chip = ({ label, onClick, className, classes = {}, color, icon = <IconCloseThin />, disabled }) => {
  return (
    <Button
      disabled={disabled}
      classes={{ container: classNames(className, styles.chip), content: styles.button, icon: classNames(styles.icon, classes.icon) }}
      onClick={onClick}
      label={label}
      icon={disabled ? null : icon}
      color={color}
    />
  );
};

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  classes: PropTypes.shape({
    icon: PropTypes.string,
  }),
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
};
export { Chip as default, Chip };
